import type { FC } from "react";
import { useMemo } from "react";

import { useLocatorTranslations } from "@locators/components/shared/hooks/useLocatorTranslations";
import { useStoreLocatorContext } from "@locators/components/shared/hooks/useStoreLocatorContext";
import classNames from "classnames";

import styles from "./StoreLocatorCount.module.scss";

type StoreLocatorCountProps = {
  className?: string;
};

export const StoreLocatorCount: FC<StoreLocatorCountProps> = (props) => {
  const { __ } = useLocatorTranslations();
  const { flotiqStores, isNoMatchingFlotiqStores } = useStoreLocatorContext();
  const storesCount = useMemo(() => flotiqStores?.length || 0, [flotiqStores]);

  if (isNoMatchingFlotiqStores) {
    return null;
  }

  return (
    <div className={classNames(styles.countLabel, props.className)} aria-live="polite">
      {__("storelocator.stores_count")}{" "}
      <span aria-label={__("storelocator.stores_count.aria_label")}>{storesCount}</span>
    </div>
  );
};
